import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    newqueriesdata:{}
}

const newqueriesSlice = createSlice({
    name: 'newqueries',
    initialState,
    reducers: {
        newqueries: (state, action) => {
            state.newqueriesdata = action.payload
        }
    }
})
export const { newqueries } = newqueriesSlice.actions;
export default newqueriesSlice.reducer